export default function slider() {
  const slider = document.querySelector(".slider_list");
  const prevButton = document.querySelector(".prev_slide");
  const nextButton = document.querySelector(".next_slide");

  if (!slider || !prevButton || !nextButton) {
    return;
  }

  const sliderItems = document.querySelectorAll(".slider_item");
  const totalItems = sliderItems.length;

  let visibleItems = 3;
  let currentIndex = 0;
  let maxIndex = totalItems - visibleItems;
  let gap = 20;
  let isEnabled = true;

  // swipe variables
  let startX = 0;
  let currentX = 0;
  let isDragging = false;

  currentIndexCheck();
  updateVisibleItems();
  window.addEventListener('resize', updateVisibleItems);

  prevButton.addEventListener("click", () => {
    if (!isEnabled) return;

    if (currentIndex > 0) {
      currentIndex--;
      updateSliderPosition();
      currentIndexCheck();
    }
  });

  nextButton.addEventListener("click", () => {
    if (!isEnabled) return;

    if (currentIndex < maxIndex) {
      currentIndex++;
      updateSliderPosition();
      currentIndexCheck();
    }
  });

  // swiping
  slider.addEventListener("touchstart", (e) => {
    if (!isEnabled) return;

    startX = e.touches[0].clientX;
    isDragging = true;
    slider.style.transition = "none";
  });

  slider.addEventListener("touchmove", (e) => {
    if (!isEnabled || !isDragging) return;

    currentX = e.touches[0].clientX;
    const deltaX = startX - currentX;
    const offset = currentIndex * (sliderItems[0].offsetWidth + gap) + deltaX;

    slider.style.transform = `translateX(-${offset}px)`;
  });

  slider.addEventListener("touchend", () => {
    if (!isEnabled || !isDragging) return;

    isDragging = false;
    slider.style.transition = "transform 0.5s ease";

    const deltaX = startX - currentX;

    if (deltaX > 50 && currentIndex < maxIndex) {
      currentIndex++;
    } else if (deltaX < -50 && currentIndex > 0) {
      currentIndex--;
    }

    currentIndexCheck();
    updateSliderPosition();
  });

  function updateSliderPosition() {
    const offset = currentIndex * (sliderItems[0].offsetWidth + gap);
    slider.style.transform = `translateX(-${offset}px)`;
  }

  function currentIndexCheck() {
    if (!isEnabled) {
      prevButton.setAttribute('disabled', true);
      nextButton.setAttribute('disabled', true);
      return;
    }

    if (currentIndex <= 0) {
      prevButton.setAttribute('disabled', true);
    } else {
      prevButton.removeAttribute('disabled');
    }

    if (currentIndex >= maxIndex) {
      nextButton.setAttribute('disabled', true);
    } else {
      nextButton.removeAttribute('disabled');
    }
  }

  function updateVisibleItems() {
    if (window.innerWidth < 361) {
      isEnabled = false;
      slider.style.transform = "none";
      currentIndex = 0;
      prevButton.setAttribute('disabled', true);
      nextButton.setAttribute('disabled', true);
      return;
    }

    isEnabled = true;

    if (window.innerWidth > 480 && window.innerWidth < 961) {
      visibleItems = 2;
      gap = 12;
    } else if (window.innerWidth < 481) {
      visibleItems = 1;
      gap = 12;
    } else {
      visibleItems = 3;
      gap = 20;
    }

    maxIndex = totalItems - visibleItems;

    if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    }

    currentIndexCheck();
    updateSliderPosition();
  }
}
